<template>
  <span>
    <font-awesome-icon
      ref="icon"
      :icon="['far', 'question-circle']"
      size="xs"
      class="icon"
    />
    <b-tooltip
      :target="() => $refs['icon']"
      :placement="placement"
      :title="title"
    >
      <slot />
    </b-tooltip>
  </span>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  title: {
    type: String,
    default: '',
  },
  placement: {
    type: String,
    default: 'bottom',
    validator: (value: string) => {
      return ['top', 'topleft', 'topright', 'right', 'righttop', 'rightbottom', 'bottom', 'bottomleft', 'bottomright', 'left', 'lefttop', 'leftbottom'].includes(value)
    },
  },
}

@Component
export default class HelpTooltip extends Vue.extend({ props }) {}

</script>

<style scoped>

.icon {
  vertical-align: text-top;
}

</style>
